// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"655":"36960ca0","760":"49b545cc"}[chunkId] + ".css";
};